import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import r from "jsonp";
import s from "query-string";
import { useState as e } from "react";

var o = function o(r) {
  var _e = e(r),
      _e2 = _slicedToArray(_e, 2),
      s = _e2[0],
      o = _e2[1];

  return {
    fields: s,
    handleFieldChange: function handleFieldChange(r) {
      o(_objectSpread(_objectSpread({}, s), {}, _defineProperty({}, r.target.id, r.target.value)));
    }
  };
},
    t = function t(o) {
  var t = {
    loading: !1,
    error: !1,
    success: !1
  },
      _e3 = e(t),
      _e4 = _slicedToArray(_e3, 2),
      c = _e4[0],
      n = _e4[1],
      _e5 = e(""),
      _e6 = _slicedToArray(_e5, 2),
      a = _e6[0],
      i = _e6[1];

  return {
    loading: c.loading,
    success: c.success,
    error: c.error,
    message: a,
    handleSubmit: function handleSubmit(e) {
      var a = s.stringify(e),
          g = o.replace("/post?", "/post-json?") + "&" + a;
      n(_objectSpread(_objectSpread({}, c), {}, {
        loading: !0
      })), i(""), r(g, {
        param: "c"
      }, function (r, s) {
        r ? (n(_objectSpread(_objectSpread({}, t), {}, {
          error: !0
        })), i(r.message)) : (n("success" !== s.result ? _objectSpread(_objectSpread({}, t), {}, {
          error: !0
        }) : _objectSpread(_objectSpread({}, t), {}, {
          success: !0
        })), i(s.msg));
      });
    },
    reset: function reset() {
      i(""), n(t);
    }
  };
};

export { o as useFormFields, t as useMailChimpForm };